import Phaser from 'phaser';
import { CodexManager } from '../ui/CodexManager';
import { CodexOverlay } from '../ui/dom/CodexOverlay';
import { BG_VOID_CSS } from '../ui/theme';

/**
 * CodexScene — thin Phaser shell around the DOM `CodexOverlay`.
 *
 * All rendering lives in the DOM layer (see design/handoff/source/codex.jsx)
 * — the scene simply owns a CodexManager instance, opens the overlay, and
 * returns control to the Menu on back. The empty Phaser camera stays behind
 * the DOM as a letterbox fill so transitions never flash the base bg.
 */
export class CodexScene extends Phaser.Scene {
  private codexManager!: CodexManager;
  private overlay: CodexOverlay | null = null;

  constructor() {
    super({ key: 'Codex' });
  }

  init(data: { codexManager?: CodexManager }): void {
    this.codexManager = data.codexManager ?? new CodexManager();
  }

  create(): void {
    this.cameras.main.setBackgroundColor(BG_VOID_CSS);

    this.overlay = new CodexOverlay(this.codexManager);
    this.overlay.on('back', () => {
      this.scene.start('Menu');
    });
    this.overlay.open();

    this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => this.tearDown());
    this.events.once(Phaser.Scenes.Events.DESTROY, () => this.tearDown());
  }

  private tearDown(): void {
    this.overlay?.close();
    this.overlay = null;
  }
}
